import { gql } from "@apollo/client";
export const checkoutPayment = gql`
mutation purchaseMemorabilia($athleteUserId:String!,$paymentFieldTokenId:String!,$paymentInfo:PaymentInfoInput!){
purchaseMemorabilia(athleteUserId:$athleteUserId,paymentFieldTokenId:$paymentFieldTokenId,paymentInfo:$paymentInfo)
{status data}
}`;
